import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRFI } from '../context/RFIContext';

function RFINotificationBar() {
  const { rfiStatus, dismissNotification } = useRFI();
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on the AI generator page itself
  const isOnRFIPage = location.pathname === '/ai-generator';

  // Show progress bar if generating and NOT on RFI page
  if (rfiStatus.isGenerating && !isOnRFIPage) {
    return (
      <div className="bg-blue-600 text-white px-4 py-2">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3 flex-1">
            <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <span className="text-sm font-medium">{rfiStatus.message}</span>
            <div className="flex-1 max-w-xs bg-blue-400 rounded-full h-2 ml-4">
              <div 
                className="bg-white h-2 rounded-full transition-all duration-500"
                style={{ width: `${rfiStatus.progress}%` }}
              />
            </div>
            <span className="text-xs opacity-80">{rfiStatus.progress}%</span>
          </div>
          <button
            onClick={() => navigate('/ai-generator')}
            className="text-sm font-medium hover:underline ml-4"
          >
            View Progress
          </button>
        </div>
      </div>
    );
  }

  // Show completion notification if complete and NOT on RFI page
  if (rfiStatus.isComplete && !isOnRFIPage) {
    return (
      <div className="bg-green-600 text-white px-4 py-2">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-medium">Your RFI is ready!</span>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate('/ai-generator')}
              className="px-3 py-1 bg-white text-green-700 rounded-md text-sm font-medium hover:bg-green-50 transition-colors"
            >
              View RFI
            </button>
            <button
              onClick={dismissNotification}
              className="p-1 hover:bg-green-500 rounded transition-colors"
            >
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

export default RFINotificationBar;
